import { render, staticRenderFns } from "./upDataImg.vue?vue&type=template&id=5c65fd07&scoped=true"
import script from "./upDataImg.vue?vue&type=script&lang=js"
export * from "./upDataImg.vue?vue&type=script&lang=js"
import style0 from "./upDataImg.vue?vue&type=style&index=0&id=5c65fd07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c65fd07",
  null
  
)

export default component.exports